import script from "./ClassificationBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassificationBar.vue?vue&type=script&setup=true&lang=js"

import "./ClassificationBar.vue?vue&type=style&index=0&id=be3abd52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be3abd52"]])

export default __exports__